"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const customErrorsMap = {
    password: {
        'custom/validCredentials': {
            text: values => (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/LoginForm/Login/ErrorMessage/InvalidCredentials:text', defaultMessage: 'You have entered an invalid email or password.', values: values })),
        },
    },
};
exports.default = customErrorsMap;
//# sourceMappingURL=customErrorsMap.js.map